@let isLoading = isFunctionalUsageLoadingSg();
@let methodologyLabel = methodologyLabelSg();
@let isAssignableMethodology = isAssignableMethodologySg();
@let allAllocations = allAllocationsSg();
@let functionalUsageChartData = functionalUsageChartDataSg();
@let missingFunctionalUsagesForSelectedAccountsWarning =
  recordWarningsPlugin.selectors
    .getMessage(WarningCode.MissingFunctionalUsagesForSelectedAccounts)
    .asSignal();
@let exclusiveFunctionsForNonExclusiveMethodologyWarning =
  recordWarningsPlugin.selectors
    .getMessage(WarningCode.ExclusiveFunctionsForNonExclusiveMethodology)
    .asSignal();
@let invalidFunctionalizationsForExclusiveMethodologyWarning =
  recordWarningsPlugin.selectors
    .getMessage(WarningCode.InvalidFunctionalizationsForExclusiveMethodology)
    .asSignal();
@let functionalUsageNotFullyCodedWarning =
  recordWarningsPlugin.selectors
    .getMessage(WarningCode.FunctionalUsageNotFullyCoded)
    .asSignal();

<div class="atn-space-functional-usage">
  <atn-ds-widget title="Functional Usage">
    @if (!isReadonlySg()) {
      <button
        actions
        class="atn-space-functional-usage__edit-button"
        [disabled]="isFunctionalUsageLoadingSg()"
        (click)="editClickHandler()"
      >
        <i class="atn-icon atn-edit atn-blue"></i>
      </button>
    }

    @if (!isLoading) {
      <div class="atn-space-functional-usage__content">
        <div class="atn-space-functional-usage__field">
          <span><b>Methodology</b></span>
          <atn-ds-value [value]="methodologyLabel" />
        </div>

        @if (isAssignableMethodology) {
          <atn-space-functional-usage-functionalizations
            [allocations]="allAllocations"
            [chartData]="functionalUsageChartData"
          />
        }
      </div>

      <div class="atn-space-functional-usage__notices">
        @if (
          isAssignableMethodology &&
          exclusiveFunctionsForNonExclusiveMethodologyWarning
        ) {
          <atn-ds-notice
            [style]="DisplayStyle.Error"
            [description]="exclusiveFunctionsForNonExclusiveMethodologyWarning"
          />
        }

        @if (
          !isAssignableMethodology &&
          invalidFunctionalizationsForExclusiveMethodologyWarning
        ) {
          <atn-ds-notice
            [style]="DisplayStyle.Error"
            [description]="
              invalidFunctionalizationsForExclusiveMethodologyWarning
            "
          />
        }

        @if (missingFunctionalUsagesForSelectedAccountsWarning) {
          <atn-ds-notice
            [style]="DisplayStyle.Warning"
            [description]="missingFunctionalUsagesForSelectedAccountsWarning"
          />
        }

        @if (functionalUsageNotFullyCodedWarning) {
          <atn-ds-notice
            [style]="DisplayStyle.Warning"
            [description]="functionalUsageNotFullyCodedWarning"
          />
        }
      </div>
    } @else {
      <div class="atn-space-functional-usage__loader">
        <atn-ds-loader />
      </div>
    }
  </atn-ds-widget>
</div>

<atn-space-functional-usage-modal />
